
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#59C982","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.25"}}),_c('path',{attrs:{"d":"M7.5 16.4c.307.004.613.048.909.13l2.12.588c.313.087.636.131.961.131h2.849a3.464 3.464 0 003.483-3.062L18 11.3a2.561 2.561 0 00-1.985-2.6l-.849-.181a.854.854 0 01-.663-.824V5.772a1.313 1.313 0 00-2.625 0v.88A4.314 4.314 0 017.5 10.9v5.5zM5.8 9.75h1.7v7.5H5.8"}})])])
          )
        }
      }
    